"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deposit = deposit;
exports.withdraw = withdraw;
exports.collectRewards = collectRewards;
const tslib_1 = require("tslib");
// src/graphql/executeMutations.ts
const client_js_1 = tslib_1.__importDefault(require("./client.js"));
const mutations_js_1 = require("./mutations.js");
async function deposit(amount, poolId) {
    const { data } = await client_js_1.default.mutate({
        mutation: mutations_js_1.DEPOSIT_MUTATION,
        variables: { amount, poolId },
    });
    if (!data)
        throw new Error("Deposit mutation returned no data");
    return data.deposit;
}
async function withdraw(amount, poolId) {
    const { data } = await client_js_1.default.mutate({
        mutation: mutations_js_1.WITHDRAW_MUTATION,
        variables: { amount, poolId },
    });
    if (!data)
        throw new Error("Withdraw mutation returned no data");
    return data.withdraw;
}
async function collectRewards(poolId) {
    const { data } = await client_js_1.default.mutate({
        mutation: mutations_js_1.COLLECT_REWARDS_MUTATION,
        variables: { poolId },
    });
    if (!data)
        throw new Error("CollectRewards mutation returned no data");
    return data.collectRewards;
}
//# sourceMappingURL=executeMutations.js.map